/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Deployment, Deployment$inboundSchema } from "./deployment.js";

export type EvolveResult = {
  deployment?: Deployment | undefined;
};

/** @internal */
export const EvolveResult$inboundSchema: z.ZodMiniType<EvolveResult, unknown> =
  z.object({
    deployment: z.optional(Deployment$inboundSchema),
  });

export function evolveResultFromJSON(
  jsonString: string,
): SafeParseResult<EvolveResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvolveResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvolveResult' from JSON`,
  );
}
